// extracted by mini-css-extract-plugin
export var button = "_8z-0";
export var icon = "_8z-1";